import { ShareProps, SocialShareButton } from './SocialShareButton.component';
import { TagCommanderService } from 'features/tagCommander/business/TagCommander.service';
import React, { ComponentProps, FC } from 'react';
import { SocialNetwork } from '@actus/types';
import { Text } from '@components/Text/Text.component';
import classnames from 'classnames';

interface Props extends Omit<ShareProps, 'socialNetwork'> {
  orientation?: 'horizontal' | 'vertical';
  socialNetworks?: SocialNetwork[];
  iconSize?: number;
  withPrefix?: boolean;
}

const defaultNetworks = [
  SocialNetwork.Facebook,
  SocialNetwork.Linkedin,
  SocialNetwork.X,
  SocialNetwork.Youtube,
  SocialNetwork.TikTok,
];

const SocialShareBar: FC<Props & ComponentProps<'div'>> = ({
  socialNetworks = defaultNetworks,
  className,
  imgUrl,
  imgAlt,
  title,
  description,
  iconSize = 30,
  withPrefix = false,
  ...rest
}) => {
  const direction = 'row';
  const rootClass = classnames('social-share-bar inline-flex align-center', direction, className);
  const socialShareClassName = 'plc-mr-s';
  const prefixClassName = 'plc-mr-s plc-mr-up-s-m';

  return (
    <div className={rootClass} {...rest}>
      {withPrefix && <Text className={prefixClassName} i18nKey="common.share-prefix" tag="div" variant="h4" />}
      {socialNetworks.map((sn) => (
        <SocialShareButton
          className={socialShareClassName}
          description={description}
          iconSize={iconSize}
          imgAlt={imgAlt}
          imgUrl={imgUrl}
          key={sn}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={(event) =>
            TagCommanderService.triggerEvent('click', event.currentTarget, {
              button_name: sn,
            })
          }
          socialNetwork={sn}
          title={title}
        />
      ))}
    </div>
  );
};

export { SocialShareBar };
